import { useRef } from "react";
import { useBioReveal } from "../hooks/gsap";
const Bio = () => {
  const bioRef = useRef(null);

  useBioReveal(bioRef);

  return (
    <div className="bio mt-20 container mx-auto overflow-hidden">
      <p ref={bioRef}>
        Full-stack developer passionate about AI/ML and creating intelligent web applications. 
        I'm a passionate AI/ML student and full-stack developer with expertise in React, Next.js, 
        Node.js, and JavaScript. I love building intelligent applications that solve real-world 
        problems and bridge the gap between cutting-edge technology and practical solutions.
      </p>
    </div>
  );
};

export default Bio;
